import {groupBy} from '@benchling/js-utils';

import {DataPointColumnsToDataType, DeprecatedDataFrame} from 'data-frames/DataFrameTypes';

/**
 * Aggregate a data frame's rows by mapping the rows into partitions, then aggregating each partition of
 * points into a single row of a new row type.
 *
 * @param dataFrame The data frame to aggregate
 * @param partitionFunction A function that maps a point to a partition key
 * @param aggregationFunction A function that reduces a partition of points to a single point
 * @param newAxisTypes The axis types for the aggregated data frame
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function aggregateRows<TDataRow, TDataRowOutput>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  partitionFunction: (row: TDataRow) => string | number,
  aggregationFunction: (rows: Array<TDataRow>) => TDataRowOutput,
  newAxisTypes: DataPointColumnsToDataType<TDataRowOutput>
): DeprecatedDataFrame<TDataRowOutput> {
  return {
    points: Object.values(groupBy(dataFrame.points, partitionFunction)).map((rows) =>
      aggregationFunction(rows)
    ),
    axisTypes: newAxisTypes,
  };
}
